import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-jobs-table-cell-renderer',
    template: `<app-jobs-table [jobsList]="jobs" view="compact" [disableDetails]="true"></app-jobs-table>`,
    styles: [],
    standalone: false
})
export class JobsTableCellRendererComponent implements OnInit, ICellRendererAngularComp {
  jobs: any;

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.jobs = params?.node?.data?.dwData?.jobs || params?.node?.data?.jobs;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams) {
    this.jobs = params?.node?.data?.dwData?.jobs || params?.node?.data?.jobs;

    return true;
  }

  constructor() {}

  ngOnInit(): void {}
}
